export default {"src":"/_next/static/media/Home.e22b3d63.svg","height":43,"width":43};